import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { CountryModel } from '../../../common/viewModels/Admin/CustomerModel';

@Component({
  selector: 'addeditlab',
  templateUrl: './addeditlab.component.html',
  styleUrls: ['./addeditlab.component.scss']
})

export class AddEditLab implements OnInit {
  labForm: FormGroup;
  lstCountries: Array<CountryModel> = [];
  lstCountriesTemp: Array<CountryModel> = [];
  isSubmitted: boolean = false;
  emailEx = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$';
  mobileNumberPattern = '^[0-9+_@#%$!&-]+$';
  showtxtState: boolean = true;
  showddrState: boolean = false;
  lstStates: any[];

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent,
    private _toastrService: ToastrService) {
  }

  ngOnInit() {
    this.labForm = this._formBuilder.group({
      LabId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
      LandlineNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      MobileNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      AftrOfficeHrsContactNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50), Validators.pattern(this.mobileNumberPattern)])],
      Fax: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      Email: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50), Validators.pattern(this.emailEx)])],
      Website: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      Address1: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(150)])],
      Address2: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(150)])],
      City: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      State: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      CountryId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
      Zip: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(10)])],
      ContactName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50)])],
      ContactNo: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(20), Validators.pattern(this.mobileNumberPattern)])],
      ContactEmail: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(50), Validators.pattern(this.emailEx)])]
    })
    this.GetCountries();
    if (this._route.snapshot.params['id'] != null && this._route.snapshot.params['id'] != undefined && this._route.snapshot.params['id'] != 0) {
      this.GetLabsById(this._route.snapshot.params['id']);
    }
  }
  filter(val: string) {
    this.lstCountries = this.lstCountriesTemp.filter(a =>
      a.Name.toLowerCase().indexOf(val.toLowerCase()) === 0);
    return this.lstCountries;
  }
  
  displayFn(country: CountryModel) {
    return country ? country.Name : country;
  }

  GetLabsById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetLabById + this._route.snapshot.params['id'])
      .subscribe(
      data => {
        this._mApp.HideLoader();
        if (data.json() != null) {
          var response = data.json().Result;  
          this.ShowHideState(response.CountryId, false);
          this.labForm.setValue(data.json().Result);
        }
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetCountries() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCountries)
      .subscribe(
      data => {
        this._mApp.HideLoader();
        this.lstCountries = data.json().Result;
        this.lstCountriesTemp = data.json().Result;
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.labForm.valid) {
      let labsDto = this.labForm.value;
      this._mApp.ShowLoader();
      this._http.post(this._appUrl.AddLab, labsDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          this._router.navigate(['/lablist']);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
  }
  ShowHideState(val, isFromView) {
    if (isFromView)
      this.labForm.controls['State'].setValue(null);
    if (val == 99) {
      this.showddrState = true;
      this.showtxtState = false;
      this.GetStates(val)
    }
    else {
      this.showddrState = false;
      this.showtxtState = true;
    }
    return;
  }

  ShowHideStateTemp(event, country, isFromView) {
    if (event.source.selected) {
      this.ShowHideState(country.CountryId, isFromView);
    }
  }

  GetStates(countryId) {
    this._http.get(this._appUrl.GetStates + countryId)
      .subscribe(
      data => {
        if (data.json().Result != null)
          this.lstStates = data.json().Result;
      },
      error => {
        this._toastrService.error(error.json().Result);
      }
      )
  }

  Clear() {
    this.labForm.reset();
  }
}